import { Address as CommonAddress } from '../common/address.model';
import { SimpleEntityActions } from '@app/classes';

export class Address extends CommonAddress {
    static permission = new SimpleEntityActions('employeeAddress');

    protected static _resource = 'companyManagement/companies/:company/employees/:employee/address';
}
